// errorMessages.ts

export interface QuoteErrorConfig {
    /** the user‐facing text */
    message: string;
    /** if true, use setCouponErrorState() instead of setError() */
    isCoupon?: boolean;
  }
  

  export const QUOTE_ERRORS: Record<string, QuoteErrorConfig> = {

    

    INVALID_COUPON: {
      message: "This coupon code is not valid. Please try again.",
      isCoupon: true,
    },
    LISTING_IS_NOT_AVAILABLE: {
      message: 'The selected dates aren’t available for this listing.',
    },
    "The minimum stay for this House is 2 days": {
      message: "The minimum stay for this House is 2 days",
    },
    "The arrival date is not valid": {
      message: "The arrival date is not valid",
    },
    'SAMEDAY_BOOKING_ERROR':
    {
      message: 'Same-day bookings aren’t available. Please select a later date.',
    }

    // …add more mappings here
  };